import { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import AuthLayout from '@/components/layouts/AuthLayout'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import MuiLink from '@mui/material/Link'

export default function ForgotPassword() {
  const { data, setData, post, processing, errors } = useForm({
    user: {
      email: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/users/password')
  }

  return (
    <AuthLayout title="Forgot Password">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, textAlign: 'center' }}>
        Enter your email address and we will send you a link to reset your password.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
        <TextField
          label="Email"
          type="email"
          fullWidth
          margin="normal"
          value={data.user.email}
          onChange={(e) => setData('user', { ...data.user, email: e.target.value })}
          error={!!errors['user.email']}
          helperText={errors['user.email']}
          autoFocus
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mt: 2, mb: 2 }}
        >
          Send Reset Link
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <MuiLink component={Link} href="/users/sign_in" underline="hover">
            Back to Sign In
          </MuiLink>
        </Box>
      </Box>
    </AuthLayout>
  )
}
